export default "__VITE_ASSET__D72mSKTz__"